import { render, staticRenderFns } from "./RequestAdd.vue?vue&type=template&id=b0b2b124&"
import script from "./RequestAdd.vue?vue&type=script&lang=ts&"
export * from "./RequestAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports